import keyMirror from 'keymirror';

export const LocaleConstants = keyMirror({
  SWITCH_LANGUAGE: null,
});
